import {ResolutionString} from "../../../../vendor/tradeview/charting_library/datafeed-api";

export function unixTimestampToDate(unixTimestamp: number): Date {
    return new Date(unixTimestamp * 1000);
}

export function unixTimestampToFormattedDate(unixTimestamp: number): string {
    return new Date(unixTimestamp * 1000).toLocaleString();
}

export function extractIntervalAndPeriod(resolution: string | ResolutionString): { frequency: number; period: any } {
    const intervalMatch = resolution.match(/\d+/g);
    const periodMatch = resolution.match(/[a-zA-Z]+/g);

    let frequency = 0;
    let period = "minute";

    if (intervalMatch) {
        frequency = Number(intervalMatch[0]);
    }

    if (periodMatch) {
        switch (periodMatch[0]) {
            case "D":
                period = "day";
                break;
            case "W":
                period = "week";
                break;
            case "M":
                period = "month";
                break;
        }
    } else if (frequency > 60) {
        period = "hour";
        frequency = 60;
    }

    return { frequency: frequency, period };
}

export const isLocal = window.location.host.indexOf("local") !== -1;

export const holidays = [
    "20240126", // Australia Day
    "20240329", // Good Friday
    "20240401", // Easter Monday
    "20240425", // ANZAC Day
    "20240610", // King's Birthday
    "20241225", // Christmas Day
    "20241226",  // Boxing Day
    "20250101", // New Year's Day
    "20250127", // Australia Day
    "20250418", // Good Friday
    "20250421", // Easter Monday
    "20250425", // ANZAC Day
    "20250609", // King's Birthday
    "20251225", // Christmas Day
    "20251226"  // Boxing Day
];